<template src="./template.html"/>

<script>
    import axios from 'axios'

    import ShopCard from "../../components/ShopCard/ShopCard";

    export default {
        name: "SearchResults",
        components: {
            ShopCard
        },
        data() {
            return {
                shops: null,
                newSearch: this.$route.params.toSearch,
                searched: '',
                loading: true
            }
        },
        watch: {
            $route() {
                this.loading = true;
                this.newSearch = this.$route.params.toSearch;
                this.shops = null;
                this.getResults();
            }
        },
        methods: {
            getResults(){
                axios({
                    method: "GET",
                    url: "/Store/search/" + this.$route.params.toSearch + "/" + this.$route.params.nResults + "/" + this.$route.params.nPage,
                    data: {}
                })
                .then(results => {
                    this.loading = false;
                    this.searched = this.$route.params.toSearch;
                    this.shops = results.data;
                })
                .catch(error => {
                    this.$bvModal.msgBoxOk("La tua ricerca ha prodotto un errore: " + error);
                })
            },
            search() {
                this.newSearch = this.newSearch.replace(/[^a-zA-Z0-9 ]/g, "");
                if (this.newSearch !== null && this.newSearch !== '' )
                    this.$router.push('/cerca/' + this.newSearch + '/' + 10 + '/' + 0).catch(err => err);
            }
        },
        mounted() {
            this.getResults();
        }

    }
</script>